<template>
  <pano-container></pano-container>
</template>

<script>
import PanoContainer from '@/components/pano-container'

export default {
  components: {
    PanoContainer,
  },
}
</script>
